import type { Input } from '@builder.io/sdk';

const productListingFields = [
  {
    name: 'cards',
    type: 'list',
    subFields: [
      {
        name: 'productType',
        type: 'string',
        enum: ['Practice', 'Business', 'Regulation'],
      },
      {
        name: 'body',
        type: 'string',
      },
    ],
  },
  {
    name: 'callToAction',
    type: 'object',
    subFields: [
      {
        name: 'text',
        type: 'string',
      },
      {
        name: 'link',
        type: 'string',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const productListingConfig = {
  name: 'Product Listing',
  inputs: productListingFields,
};

export type ProductListingType = GenerateBuilder<typeof productListingFields>;

export default productListingConfig;
